export const MAX_CART_ITEM_QUANTITY_PRODUCT_DETAIL = 100;
export const MAX_CART_ITEM_QUANTITY_CART_PAGE = 999;
export const MIN_CART_ITEM_QUANTITY = 1;
export const OUT_OF_STOCK_CODE = 102;
export const INSUFFICIENT_STOCK_CODE = 103;
export const HOTLINE_NUMBER = '18006608';
export const ACTIVE_PRODUCT_GALLERY_SELECTORS = [
    '.product-gallery .swiper-slide-active img',
    '.product-gallery .slick-current img',
    '.product-gallery [aria-hidden="false"] img',
    '.product-gallery [data-active="true"] img',
    '.product-gallery .is-active img',
    '.product-gallery .active img',
] as const;
